__turbopack_context__.v({
  "accordion-down": "accordion-module__mNjBbG__accordion-down",
  "accordion-up": "accordion-module__mNjBbG__accordion-up",
  "chevron": "accordion-module__mNjBbG__chevron",
  "content": "accordion-module__mNjBbG__content",
  "contentInner": "accordion-module__mNjBbG__contentInner",
  "header": "accordion-module__mNjBbG__header",
  "item": "accordion-module__mNjBbG__item",
  "trigger": "accordion-module__mNjBbG__trigger",
});
